import { Layout, Spin } from "antd";
import { Content } from "antd/lib/layout/layout";
import { ReactElement } from "react";
import { AppFooter } from "./footer/AppFooter";
import { AppHeader } from "./header/AppHeader";
import s from "./ShellFallback.module.scss";

// Fallback di Suspense per le shell lazy (/app, /console): mostra la stessa
// cornice brandizzata (header + footer) con uno spinner centrato, così durante
// il download del chunk non compare una pagina nuda senza chrome.
export function ShellFallback(): ReactElement {
  return (
    <Layout className={s.layout}>
      <AppHeader />
      <Content className={s.content}>
        <Spin size="large" />
      </Content>
      <AppFooter />
    </Layout>
  );
}
